export default __webpack_public_path__ + "static/media/Formato de Transacciones Masivas_IDEA.3db23bb5.xlsm";